<template >
    <div v-if="pt152Init && pt152Init.partsHeaList && pt152Init.partsHeaList.length > 0" :class="pt152Init.partsHeaList[0].ORG_PARTS_CLASS ? (pt152Init.partsHeaList[0].ORG_PARTS_CLASS):('pt152class')" v-cloak>
        <h2 :class="pt152Init.partsHeaList[0].ORG_TITLE_CLASS ? (pt152Init.partsHeaList[0].ORG_TITLE_CLASS):('pt152class')">{{pt152Init.partsHeaList[0].ORG_TITLE}}</h2>
        <!-- スライダー（商品指定）-->
        <slick v-if="pt152Init.partsHeaList[0].ORG_PARTS_DISP_KBN == 1 && pt152Init.partsHeaList[0].ORG_ITEM_SP_KBN == 1" :class="pt152Init.partsHeaList[0].ORG_LIST_CLASS ? (pt152Init.partsHeaList[0].ORG_LIST_CLASS):('pt152class')" ref="slick" :options="slickOptions">
            <div v-for="(partsMei, index) in pt152Init.partsMeiList" :key="index" class="slick-slide">
                <p v-if="partsMei.TITLE_TAG" v-html="partsMei.TITLE_TAG"></p>
                <router-link :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO):('pt152class' + partsMei.LINE_NO)" :to="{ name: SiteConstants.PG030, params: {pageNo: 3, sItemNo: partsMei.S_ITEM_CD}}">
                    <span v-if="partsMei.CONTENT_TAG" v-html="partsMei.CONTENT_TAG"></span>
                    <img v-if="partsMei.IMG_URL1" :src="partsMei.IMG_URL1" alt="" :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO + 'img') :('pt152class' + partsMei.LINE_NO + 'img')" @error="getErrImage">
                    <img v-else src="defaultImagePath" alt="" :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO + 'img') :('pt152class' + partsMei.LINE_NO + 'img')" @error="getErrImage">
                    <span class="webNm" v-if="partsMei.ORG_ITEM_NM_DISP_FLG == 1">{{partsMei.WEB_ITEM_NM}}</span>
                    <span v-if="partsMei.ORG_TNK_DISP_FLG == 1">
                        <span class="generalPrice" v-if="partsMei.ZEI_SET_KBN == 1">{{formatPrice(partsMei.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}</span>
                        <span class="generalPrice" v-else>{{formatPrice(partsMei.SALE_TNK)}}{{$t('common.labels.jpYen')}}</span>
                    </span>
                    <!-- 商品ステータス -->
                    <div class="toyakiContainer" v-if="partsMei.ORG_STATUS_DISP_FLG == 1">
                        <div v-for="i in 15" :key="i">
                            <span :class="'itemIcon'+ (i<10 ? '0':'') + i" v-if="partsMei[`ITEM_STATUS${i}`]  == 0">
                                <font :class="'itemIconStar'+ (i<10 ? '0':'') + i" color="gold" style="font-size:11px;">{{$t('pt120.labels.star')}}</font>
                                <font :class="'itemIconNm'+ (i<10 ? '0':'') + i" color="#ff0033" style="font-size:11px;">{{partsMei[`ICON_NM${i}`]}}</font>
                            </span>
                        </div>
                    </div>
                </router-link>
                <!-- お気に入り -->
                <div class="favourite" v-if="pt152Init.partsHeaList[0].ORG_ITEM_SP_KBN == 1 && partsMei.ORG_OKINI_DISP_FLG == 1 && pt152Init.loginKbn">
                    <button v-if="partsMei.OKINI_FLG == 0" class="btn btn-favourite" @click="pt152favorites(1,partsMei.S_ITEM_CD,partsMei.WEB_ITEM_NM,index);"></button>
                    <button v-else class="btn btn-delete" @click="pt152favorites(2,partsMei.S_ITEM_CD,partsMei.WEB_ITEM_NM,index);"></button>
                </div>
            </div>
        </slick>
        <!-- スライダー（URL指定）-->
        <slick v-if="pt152Init.partsHeaList[0].ORG_PARTS_DISP_KBN == 1 && pt152Init.partsHeaList[0].ORG_ITEM_SP_KBN == 2"  :class="pt152Init.partsHeaList[0].ORG_LIST_CLASS ? (pt152Init.partsHeaList[0].ORG_LIST_CLASS):('pt152class')" ref="slick" :options="slickOptions">
            <div v-for="(partsMei, index) in pt152Init.partsMeiList" :key="index" class="slick-slide">
                <p v-if="partsMei.TITLE_TAG" v-html="partsMei.TITLE_TAG"></p>
                <a v-if="pt152Init.partsHeaList[0].ORG_ITEM_SP_KBN == '2'" :href="partsMei.URL" :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO):('pt152class' + partsMei.LINE_NO)">
                <span v-if="partsMei.CONTENT_TAG" v-html="partsMei.CONTENT_TAG"></span>
                <img v-if="partsMei.IMG_PATH" :src="partsMei.IMG_PATH" alt="" :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO + 'img') :('pt152class' + partsMei.LINE_NO + 'img')">
                </a>
            </div>
        </slick>
        <!-- リスト（商品指定） -->
        <ul v-if="pt152Init.partsHeaList[0].ORG_PARTS_DISP_KBN == 2 && pt152Init.partsHeaList[0].ORG_ITEM_SP_KBN == 1" :class="pt152Init.partsHeaList[0].ORG_LIST_CLASS ? (pt152Init.partsHeaList[0].ORG_LIST_CLASS):('pt152class')">
            <li v-for="(partsMei, index) in pt152Init.partsMeiList" :key="index">
                <p v-if="partsMei.TITLE_TAG" v-html="partsMei.TITLE_TAG"></p>
                <a :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO):('pt152class' + partsMei.LINE_NO)" @click="selectLink(partsMei.S_ITEM_CD)">
                    <span v-if="partsMei.CONTENT_TAG" v-html="partsMei.CONTENT_TAG"></span>
                    <img :src="partsMei.IMG_URL1" alt="" :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO + 'img') :('pt152class' + partsMei.LINE_NO + 'img')" @error="getErrImage">
                    <span class="webNm" v-if="partsMei.ORG_ITEM_NM_DISP_FLG == 1">{{partsMei.WEB_ITEM_NM}}</span>
                    <span v-if="partsMei.ORG_TNK_DISP_FLG == 1">
                        <span class="generalPrice" v-if="partsMei.ZEI_SET_KBN == 1">{{formatPrice(partsMei.SALE_ZEI_K_TNK)}}{{$t('common.labels.jpYen')}}</span>
                        <span class="generalPrice" v-else>{{formatPrice(partsMei.SALE_TNK)}}{{$t('common.labels.jpYen')}}</span>
                    </span>
                    <!-- 商品ステータス -->
                    <div class="toyakiContainer" v-if="partsMei.ORG_STATUS_DISP_FLG == 1">
                        <div v-for="i in 15" :key="i">
                            <span :class="'itemIcon'+ (i<10 ? '0':'') + i" v-if="partsMei[`ITEM_STATUS${i}`]  == 0">
                                <font :class="'itemIconStar'+ (i<10 ? '0':'') + i" color="gold" style="font-size:11px;">{{$t('pt120.labels.star')}}</font>
                                <font :class="'itemIconNm'+ (i<10 ? '0':'') + i" color="#ff0033" style="font-size:11px;">{{partsMei[`ICON_NM${i}`]}}</font>
                            </span>
                        </div>
                    </div>
                </a>
                <!-- お気に入り -->
                <div class="favourite" v-if="pt152Init.partsHeaList[0].ORG_ITEM_SP_KBN == 1 && partsMei.ORG_OKINI_DISP_FLG == 1 && pt152Init.loginKbn">
                    <button v-if="partsMei.OKINI_FLG == 0" class="btn btn-favourite" @click="pt152favorites(1,partsMei.S_ITEM_CD,partsMei.WEB_ITEM_NM,index);"></button>
                    <button v-else class="btn btn-delete" @click="pt152favorites(2,partsMei.S_ITEM_CD,partsMei.WEB_ITEM_NM,index);"></button>
                </div>
            </li>
        </ul>
        <!-- リスト（URL指定） -->
        <ul v-if="pt152Init.partsHeaList[0].ORG_PARTS_DISP_KBN == 2 && pt152Init.partsHeaList[0].ORG_ITEM_SP_KBN == 2" :class="pt152Init.partsHeaList[0].ORG_LIST_CLASS ? (pt152Init.partsHeaList[0].ORG_LIST_CLASS):('pt152class')">  
            <li v-for="(partsMei, index) in pt152Init.partsMeiList" :key="index">
                <p v-if="partsMei.TITLE_TAG" v-html="partsMei.TITLE_TAG"></p>
                <a v-if="pt152Init.partsHeaList[0].ORG_ITEM_SP_KBN == '2'" :href="partsMei.URL" :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO):('pt152class' + partsMei.LINE_NO)">
                <span v-if="partsMei.CONTENT_TAG" v-html="partsMei.CONTENT_TAG"></span>
                <img :src="partsMei.IMG_PATH" alt="" :class="pt152Init.partsHeaList[0].ORG_DTL_CLASS ? (pt152Init.partsHeaList[0].ORG_DTL_CLASS + partsMei.LINE_NO + 'img') :('pt152class' + partsMei.LINE_NO + 'img')" @error="getErrImage">
                </a>
            </li>
        </ul>
    </div>
</template>
<script>
/* 
* Import libs and componnents
*/
import common from "assets/js/common";
import axios from "assets/js/request";
import SiteConstants from 'assets/const/SiteConstants.json';
import Constants from 'assets/const/Constants.json';
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";
import Slick from 'vue-slick';
import "assets/css/slick-theme.css";
import "assets/css/slick.css";
import $ from "jquery";

export default {
    /* 
    * Name of component
    */
    name: "PT152OriginalParts",
    /* 
    * Get data from parent component
    */
    components: {
        toastr,
        Slick
    },
    props: {
        partsNo: {
            type: Number
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    data() {
        return {
            pt152ListSize:null,
            pt152Init:{
                loginKbn: false,
                partsHeaList: [],
                partsMeiList: [],
            },
            listIdErr:[],
            pt152ReqModel:{
              partsNo: null,
              itemCd: null
            },
            htmlTxt:null,
            scriptTxt: null,
            scriptUrl: null,
            htmlAlign:null,
            site: "",
            SiteConstants: SiteConstants,
            Constants: Constants,
            slickOptions: { //スライダーのオプション設定
            dots: true, // ナビゲーションドットを表示する
            infinite: true, // 無限スクロール
            speed: 500, // トランジションの速度
            slidesToShow: 1, // 表示するスライド数
            slidesToScroll: 1, // スクロールするスライド数
            autoplay:true, // 自動再生
            autoplaySpeed: 3000, // 自動再生のスピード  
            centerMode: true, // センターモード
            centerPadding: '15%', // センターモードのパディング
            lazyLoad: 'ondemand', // 画像の遅延読み込み
            },
            defaultImagePath: common.getImgDefault(),
        }
    },
    
    mounted() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];
        // eslint-disable-next-line
        _this.pt152ReqModel.partsNo = _this.partsNo;

        if (_this.ptInitData){
            _this.pt152Init = _this.ptInitData;
            _this.pt152ListSize = _this.pt152Init.bannerInfo;
            _this.htmlTxt = _this.ptInitData.html;
            _this.scriptTxt = _this.ptInitData.scriptTxt;
            _this.scriptUrl = _this.ptInitData.scriptUrl;
        }else{
            _this.doInit();
        }
    },

    methods: {
        doInit: function() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT152 + _this.$UrlConstants.DO_INIT ,_this.pt152ReqModel).then(function(response) {
                _this.pt152Init = response.data;
            }).catch(function(error) {
                common.errorAPI(error);
            });
        },
        selectLink: function(itemNo) {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG030, params: {pageNo: 3, sItemNo : itemNo}});
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        /**
         * format number value to currency value
         * @param {number} value, number to format
         */
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /*
        * お気に入り登録・解除処理
        * processKbn 1:登録 2:解除
        */
        pt152favorites: function(processKbn,sItemCd,webItemNm,index) {
            var _this = this;
            // 登録処理
            _this.pt152ReqModel.itemCd = sItemCd;
            if (processKbn == 1) {
                _this.$emit("event-loading", true);
                //doFavourite
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT152 + _this.$UrlConstants.DO_FAVORITE, _this.pt152ReqModel).then(function(response) {
                    if(response.data.status == 'OK'){
                        // 登録完了
                        _this.msgConfirm = webItemNm + _this.$i18n.t("pt110.labels.favouriteAdd");
                        toastr.success(_this.msgConfirm);
                        _this.doInit();
                    } else {
                        // 登録失敗
                        _this.msgConfirm = webItemNm + _this.$i18n.t("pt110.labels.favouriteError");
                        _this.isModalShow = true;
                    }
                    _this.$emit("event-loading", false);
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                });
            // 解除処理
            } else if (processKbn == 2) {
                axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT152 + _this.$UrlConstants.DO_DELETE, _this.pt152ReqModel).then(function() {
                    _this.msgConfirm = webItemNm + _this.$i18n.t("pt110.labels.favouriteDel");
                    toastr.success(_this.msgConfirm);
                    _this.$emit("event-loading", false);
                    _this.doInit();
                }).catch(function(error) {
                    _this.$emit("event-loading", false);
                    common.errorAPI(error);
                });
            }
        },
    }
}
</script>
<style scoped>
.slick-slider {
  padding: 0;
  margin: 0;
  list-style: none;
  width: 100%;
}

.slick-slide {
  text-align: center;
  width: 100%;
}

.slick-slide img {
  width: 100%;
  height: auto;
}

.slick-slide.slick-cloned button.btn.btn-favourite {
  display: none;
}
</style>
